module.exports = __webpack_public_path__ + "static/media/3.196624ee.png";